var exports = {
  "k": "xaf9ae18d--79b66b--container",
};

module.exports = exports;
